// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"c88f6f2ec0a83f6c3454","715":"fcd870944840fcc6b2bc","962":"81902f28c05e9a4103df"}[chunkId] + ".css";
};